import Customer from '../domain/Customer'

export default class AuthService {
  static currentCustomer = () => global.AuthDispatcher && global.AuthDispatcher.isLogged() && global.AuthDispatcher.currentCustomer
    ? Customer.fromJSON(global.AuthDispatcher.currentCustomer)
    : Customer.anonymous()

  static onAuthenticated = (handler) =>
    global.$(window).on('auth.logged auth.postlogged', (event, data, preventRefresh) =>
      handler(Customer.fromJSON(data), preventRefresh))

  static onUnauthenticated = (handler) =>
    global.$(window).on('auth.nologged', (event, data, preventRefresh) =>
      handler(Customer.anonymous(), preventRefresh))
}
